import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logoV from '../../Assets/logo.png';
import './Navigationbar.css';

const Navigationbar = () => {
  const [activeSection, setActiveSection] = useState('home'); // Initialize with 'home'

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'services', 'customers', 'gallery', 'news', 'about', 'contact'];
      let currentSection = 'home';
      
      for (let section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          // Adjusted threshold - section is active when its top is within viewport
          if (rect.top <= 100 && rect.bottom > 100) {
            currentSection = section;
          }
        }
      }
      
      setActiveSection(currentSection);
    };

    handleScroll();
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Navbar expand="lg" className="custom-navbar sticky-top" style={{ backgroundColor: "#1a2332"}}>
      <Container fluid>
        <Navbar.Brand href="/">
          <div className='logo'>
            <img
              src={logoV}
              alt="VTAS Logo"
              style={{ objectFit: "contain", width: "100px", height: "100px" }}
            /><br/>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link 
              href="#home" 
              className={activeSection === 'home' ? 'home active' : 'home'}
            >
              Home
            </Nav.Link>
            <Nav.Link 
              href="#services" 
              className={activeSection === 'services' ? 'services active' : 'services'}
            >
              Services
            </Nav.Link>
            <Nav.Link 
              href="#customers" 
              className={activeSection === 'customers' ? 'customers active' : 'customers'}
            >
              Customers
            </Nav.Link>
            <Nav.Link 
              href="#gallery" 
              className={activeSection === 'gallery' ? 'gallery active' : 'gallery'}
            >
              Gallery
            </Nav.Link>
            <Nav.Link 
              href="#news" 
              className={activeSection === 'news' ? 'news active' : 'news'}
            >
              News
            </Nav.Link>
            <Nav.Link 
              href="#about"
              className={activeSection === 'about' ? 'about active' : 'about'}
            >
              About Us
            </Nav.Link>
            <Nav.Link 
              href="#contact" 
              className={activeSection === 'contact' ? 'contact active' : 'contact'}
            >
              Contact Us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigationbar;